import { render, staticRenderFns } from "./AlertsForm.vue?vue&type=template&id=18574182&"
import script from "./AlertsForm.vue?vue&type=script&lang=js&"
export * from "./AlertsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18574182')) {
      api.createRecord('18574182', component.options)
    } else {
      api.reload('18574182', component.options)
    }
    module.hot.accept("./AlertsForm.vue?vue&type=template&id=18574182&", function () {
      api.rerender('18574182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/alerts/AlertsForm.vue"
export default component.exports